import React, { Component, useState } from 'react';
import { Row, Col, Image, Button, Modal } from 'react-bootstrap';
import LanguageButton from "src/img/Settings Icon.png"
import { withTranslation, useTranslation} from 'react-i18next';


class LanguageChange extends Component {

    render() {
        return (
            <LanguageLogo />
        );
    }
}

function LanguageLogo(){
    const [ show, setShow ] = useState(false);
    const { i18n } = useTranslation();

    // 言語切り替え後、ローカルストレージに選択した言語を保持
    const changeLanguage = (lng) => {    
        i18n.changeLanguage(lng); 
        setShow(false);
        localStorage.setItem('lng', lng);
    };
    
    const handleShow = () => {
        setShow(true)
    }

    const handleHide = () => {
        setShow(false)
    }
    
    return (
        <Col className="logo-child" id="language-button" >
            <Image src={LanguageButton} onClick={() => handleShow()}></Image>
            <Modal
                show={show}
                onHide={() => handleHide()}
                dialogClassName="change-language-modal"
            >
                <Row>
                    <Col>
                        <Button id="change-button" onClick={() => changeLanguage('en')}>
                            English
                        </Button>
                    </Col>
                    <Col>
                        <Button id="change-button" onClick={() => changeLanguage('id')}>
                            Bahasa Indonesia
                        </Button>
                    </Col>
                </Row>
            </Modal>
        </Col>
    );
}

export default withTranslation()(LanguageChange);



// WEBPACK FOOTER //
// ./src/js/LanguageChange.js